import styled from '@emotion/styled/macro';

export const Stash = styled('div')`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
`;

export const Compact = styled('div')`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
`;

export const Full = styled('div')`
  flex: 1;
`;

export const ExpandButton = styled('button')`
  padding: 0px 4px;
  border-radius: 3px;
  border: none;
  line-height: 16px;
  font-weight: bold;
  display: none;

  color: var(--ds-text-subtle);
  background-color: var(--ds-background-inverse-subtle);
  &:hover {
    background-color: var(--ds-background-inverse-subtle-hovered);
  }
`;

export const CommentBlock = styled('div')``;

export const CommentBody = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: bottom;
  max-width: 100%;
  padding: 4px;
  gap: 4px;
`;

export const CommentText = styled('div')`
  white-space: pre-wrap;
`;

export const CommentControlls = styled('div')`
  flex: 0;
  width: 30px;
`;

export const CommentParagraph = styled('p')`
  margin: 0 0 1em;

  &:last-child {
    margin: 0;
  }
`;
